module.exports = __webpack_public_path__ + "img/Star rating Icon - charcoal.44dc2f82.svg";